import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Gamification from "../../containers/gamification/gamification";
import Sidebar from "../../containers/sidebar/sidebar";
import useHomePathFinder from "../../hooks/useHomePathFinder";

const GamificationIndex = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [hasAccess, availablePaths] = useHomePathFinder(location.pathname);
    useEffect(() => {
        if (hasAccess) {
            // console.log("granted");
        } else {
            navigate(
                availablePaths?.length > 0 ? availablePaths[0] : "/settings"
            );
        }
    }, []);
    return (
        <div className="text-white  min-h-screen">
            <div className="flex">
                <Sidebar />
                <Gamification />
            </div>
        </div>
    );
};

export default GamificationIndex;
